import { FC } from 'react';
import {
  Input,
  Box,
  Text,
  Center,
  Grid,
  GridItem,
  Container,
  List,
  ListItem,
  Stack,
  //2025.06 COMTEC kawaji ADD START
  Alert,
  AlertIcon,
  AlertDescription,
  //2025.06 COMTEC kawaji ADD END
} from '@chakra-ui/react';

import { ComponentsWithLabel } from '../molecules/ComponentsWithLabel';
import { PageSendButton } from '../atom/button/PageSendButton';
import { DefaultLayout } from '../templates/DefaultLayout';
import { ErrorMessage } from '../atom/Text/ErrorMessage';
import { AlertWithIcon } from '../atom/alert/AlertWithIcon';
import { useMail } from '../hooks/useMail';
import { CorrectCheckIcon } from '../atom/icon/ColorIcons';
import '../templates/Teikihoan.css';

export const InputMail: FC = () => {
  const {
    inputItems,
    ngMailManuals,
    errMsg,
    isValid,
    errors,
    inputMailAddress,
    currentStep,
    isShowMoveButton, //2025.08 COMTEC kawaji ADD

    handleSubmit,
    handleBack,
    register,
    setError,
    clearErrors,
    getValues,
    MoveToHp,
  } = useMail();

  return (
    <>
      <DefaultLayout>
        <Container maxW="container.md">
          {currentStep === 0 && (
            <form onSubmit={handleSubmit}>
              <Box m={5}>
                <Text mb={5}>
                  {/* 2025.08 COMTEC kawaji DEL START */}
                  {/* 予約フォームのアドレス（URL）をお送りします。
                  <br /> */}
                  {/* 2025.08 COMTEC kawaji DEL END */}
                  送信先のメールアドレスをご入力の上、「送信」ボタンを押してください。
                </Text>
                <Grid
                  templateRows="repeat(4,1fr)"
                  templateColumns="repeat(2, 1fr)"
                  mb={5} //2025.08 COMTEC kawaji ADD
                >
                  {inputItems.map((item, index) => {
                    const colSpan = item.colSpan ? item.colSpan : 1;
                    return (
                      <GridItem key={index} colSpan={colSpan} m={1}>
                        <ComponentsWithLabel label={item.label} noticed={false}>
                          <Input
                            type={item.type}
                            placeholder={item.label}
                            required={true}
                            borderColor={
                              errMsg &&
                              (item.name === 'mailAddress' ||
                                item.name === 'mailAddress2')
                                ? 'red.500'
                                : 'gray.200'
                            }
                            {...register(item.name, {
                              required: true,

                              validate: (value) => {
                                if (item.name === 'mailAddress2') {
                                  return (
                                    getValues().mailAddress2 ===
                                      getValues().mailAddress ||
                                    'メールアドレスが一致しません。'
                                  );
                                }
                                if (
                                  item.name === 'mailAddress' &&
                                  getValues().mailAddress2 !== ''
                                ) {
                                  if (
                                    getValues().mailAddress2 !==
                                    getValues().mailAddress
                                  ) {
                                    setError('mailAddress2', {
                                      type: 'manual',
                                      message: 'メールアドレスが一致しません。',
                                    });
                                  } else {
                                    clearErrors('mailAddress2');
                                  }
                                  return true;
                                }
                              },
                            })}
                          />
                          <ErrorMessage>
                            {errors[item.name] ? (
                              errors[item.name]?.message
                            ) : (
                              <>　</>
                            )}
                          </ErrorMessage>
                        </ComponentsWithLabel>
                      </GridItem>
                    );
                  })}
                  {/* 2025.06 COMTEC kawaji ADD START */}
                  <GridItem colSpan={2}>
                    <Alert status="warning">
                      <AlertIcon />
                      <AlertDescription fontSize={'sm'}>
                        ご入力いただいたメールアドレス宛に
                        <Text as="b">
                          予約フォームのご案内メールを送信します。
                        </Text>
                        <br />
                        届きましたメールからお手続きください。
                        <br />
                        <Text fontWeight="bold" mt="1" color={'orange.800'}>
                          セキュリティ設定をされている場合は、ドメイン＠nihongas.co.jpからの受信を有効にしてください。
                        </Text>
                      </AlertDescription>
                    </Alert>
                  </GridItem>
                  {/* 2025.06 COMTEC kawaji ADD END */}
                </Grid>
                {errMsg && (
                  <AlertWithIcon status="error" mb={5} text={errMsg} />
                )}
                <Center>
                  <Box w={'50%'} maxW={'300px'} m={1}>
                    <PageSendButton
                      text="戻る"
                      type="button"
                      disabled={false}
                      onClick={handleBack}
                    ></PageSendButton>
                  </Box>
                  <Box w={'50%'} maxW={'300px'}>
                    <PageSendButton
                      text="送信"
                      type="submit"
                      disabled={!isValid}
                    ></PageSendButton>
                  </Box>
                </Center>
              </Box>
            </form>
          )}
          {currentStep === 1 && (
            <Box m={5}>
              <Text as="ins" fontSize="2xl">
                メールの送信が完了しました。
              </Text>
              <Box mt={5}>
                <Text>
                  受付と同時にシステムから[{inputMailAddress}
                  ]宛に、予約フォームに関するメールをお送りしています。
                </Text>
              </Box>
              <Box mt={10} mb={8}>
                <Text mb={4}>
                  {/* 万が一 --2025.08 COMTEC kawaji DEL*/}
                  メールが届かない場合、以下をご確認ください。
                </Text>
                <List spacing={3}>
                  {ngMailManuals.map((manual, index) => {
                    return (
                      <ListItem key={index}>
                        <Stack direction={'row'}>
                          <CorrectCheckIcon />
                          <Box className="list-row">{manual}</Box>
                        </Stack>
                      </ListItem>
                    );
                  })}
                </List>
              </Box>
              {/* 2025.08 COMTEC kawaji MOD START --定期保安のみサポートページボタンを表示するよう修正*/}
              {/* <Center>
                  <Box w={'50%'} maxW={'300px'}>
                    <PageSendButton
                      text="お客さまサポートページトップ"
                      type="button"
                      onClick={MoveToHp}
                    ></PageSendButton>
                  </Box>
                </Center> */}
              {isShowMoveButton ? (
                <Center>
                  <Box w={'50%'} maxW={'300px'}>
                    <PageSendButton
                      text="お客さまサポートページトップ"
                      type="button"
                      onClick={MoveToHp}
                    ></PageSendButton>
                  </Box>
                </Center>
              ) : (
                <></>
              )}
              {/* 2025.08 COMTEC kawaji MOD END */}
            </Box>
          )}
        </Container>
      </DefaultLayout>
    </>
  );
};
